var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('navbar-component'),_c('main',[_c('router-view')],1),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }